
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { LinkButton } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import ClientOnlyPrice from '../ClientOnlyPrice.vue';

interface PackageFeature {
  text: string;
  isInheritedText: boolean;
  icon: string;
}

interface PackageAsset {
  src: string;
  alt: string;
}

export default defineComponent({
  name: 'PackageCard',
  components: {
    LinkButton,
    FCImage,
    ClientOnlyPrice,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      default: 0,
    },
    oldPrice: {
      type: Number,
      default: 0,
    },
    image: {
      type: Object as PropType<PackageAsset>,
      required: true,
    },
    bonuses: {
      type: Array as PropType<Array<{ productName: string }>>,
      default: () => [],
    },
    features: {
      type: Array as PropType<PackageFeature[]>,
      required: true,
    },
    ctaLink: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      default: 'Shop now',
    },
    titleColorClass: {
      type: String,
      default: '',
    },
    isBestValue: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { $store } = useNuxtApp();

    const visitorCountry = computed(() => {
      const country = $store.state.app.geoLocationCountry;
      return !country || country === 'US' ? 'US' : country;
    });

    const isUSVisitor = computed(() => visitorCountry.value === 'US');

    const getBonusValue = (productName: string): string => {
      const bonusValueMap: Record<string, Record<string, string>> = {
        US: {
          'Boxing Gloves': '$119',
          'Double Your Gear': '$197',
        },
        CA: {
          'Boxing Gloves': '$169',
          'Double Your Gear': '$250',
        },
      };

      return bonusValueMap[visitorCountry.value]?.[productName] || '';
    };

    return {
      getBonusValue,
      isUSVisitor,
    };
  },
});
